import Tooltip from '@components/Tooltips/Tooltip';
import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const InfoContainer = styled.div<{padding?:boolean}>`
  width:20px;
  position: absolute;
  top: ${props => props.padding?"20px":"0px"};
  right: ${props => props.padding?"20px":"0px"};
  cursor: pointer;
  
  > div > svg{
    path{
      opacity: 0.4;
      transition: all 0.1s ease-in-out;
      fill:#277982;
    }
  }

  :hover{
    > div > svg{
      path{
        opacity: 0.9;
        fill:#277982;
      }
    }
  }
`;